import MEMBER_STATUS_LIST from 'constants/memberStatusList';
import ACCESS_LEVEL_LIST from 'constants/accessLevelList';

const Member = (memberObj) => {
    /**
     * Gets the email from an Sugar APi object
     */
    const getEmailFromSugarAPIObj = () => {
        if (
            typeof memberObj === 'object'
            && Object.hasOwnProperty.call(memberObj, 'primary_email_address')
            && memberObj.primary_email_address.length > 0
            && Object.hasOwnProperty.call(memberObj.primary_email_address[0], 'email_address')
            && memberObj.primary_email_address[0].email_address
        ) {
            return memberObj.primary_email_address[0].email_address;
        }
        return '';
    };

    const getAccessLevelFromSugarAPIObj = () => {
        if (
            typeof memberObj === 'object'
            && Object.hasOwnProperty.call(memberObj, 'cstm')
            && Object.hasOwnProperty.call(memberObj.cstm, 'portal_access_c')
            && memberObj.cstm.portal_access_c
        ) {
            return memberObj.cstm.portal_access_c;
        }
        return '';
    };

    const getStatusFromSugarAPIObj = () => {
        if (
            typeof memberObj === 'object'
            && Object.hasOwnProperty.call(memberObj, 'cstm')
            && Object.hasOwnProperty.call(memberObj.cstm, 'cognito_portal_active_c')
            && memberObj.cstm.cognito_portal_active_c
        ) {
            return memberObj.cstm.cognito_portal_active_c;
        }
        return '';
    };

    /**
     * Sets the information based on Sugar API response if exists, otherwise creates an empty object
     */
    const newMemberObj = {
        id: memberObj && Object.hasOwnProperty.call(memberObj, 'id') && memberObj.id ? memberObj.id : '',
        firstName: memberObj && Object.hasOwnProperty.call(memberObj, 'first_name') && memberObj.first_name
            ? memberObj.first_name : '',
        lastName: memberObj && Object.hasOwnProperty.call(memberObj, 'id') && memberObj.last_name
            ? memberObj.last_name : '',
        email: getEmailFromSugarAPIObj(),
        accessLevel: getAccessLevelFromSugarAPIObj(),
        memberStatus: getStatusFromSugarAPIObj()
    };

    const memberKeys = Object.keys(newMemberObj);

    /**
     * Populates the object with the input member object if contains the correct keys/values
     */
    for (const key in memberObj) {
        if (memberKeys.includes(key)) {
            newMemberObj[key] = memberObj[key];
        }
    }

    return {
        ...newMemberObj,
        getMemberStatusLabel() {
            for (const obj of MEMBER_STATUS_LIST) {
                if (obj.value === this.memberStatus) {
                    return obj.name;
                }
            }
            return '';
        },
        getAccessLevelLabel() {
            for (const obj of ACCESS_LEVEL_LIST) {
                if (obj.value === this.accessLevel) {
                    return obj.name;
                }
            }
            return '';
        },
        /**
         * Formats the data to send the form to create/update a member
         * @returns {Object}
         */
        getSugarAPIFormat() {
            return {
                id: this.id,
                first_name: this.firstName,
                last_name: this.lastName,
                email_address: this.email,
                cognito_portal_active_c: this.memberStatus,
                portal_access_c: this.accessLevel
            };
        },
        /**
         * Formats the data to display in the manage practice table
         * @returns {Object}
         */
        customTableFormat() {
            return {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                accessLevel: this.accessLevel
            };
        }
    };
};

export default Member;
